<template>
  <div class="admin-login position-relative" style="background-color: whitesmoke;">
    <div class="shadow border card p-4">
      <h4 class="text-center">Login</h4>
      <div>
        <label>Usuario</label>
        <input 
          class="form-control" 
          type="text" 
          v-model="username" 
          @keyup.enter="authLogin" 
        />
      </div>
      <div class="mt-3">
        <label>Password</label>
        <input 
          class="form-control" 
          type="password" 
          v-model="password" 
          @keyup.enter="authLogin" 
        />
      </div>
      <div class="text-end mt-3">
        <button class="btn btn-success" @click="authLogin">Aceptar</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  name: 'HomeView',
  mounted() {
    this.auth_logout().then(() => toast.success("Deslogueado correctamente"));
  },
  data() {
    return {
      username: '',
      password: ''
    };
  },  
  methods: {
    ...mapActions("auth", ["auth_login"]),
    ...mapActions("auth", ["auth_logout"]),
    async authLogin() {
      try {
        let response = await this.auth_login({email: this.username, password: this.password});

        console.log(response);
        if (response.status == 200) {
          this.$router.push('/admin/reservas');
        }
      } catch (error) {
        console.log(error);
        toast.error('Error ingresando al sistema')
      }
    }
  },
  
};
</script>

<style scoped>
.admin-login {
  min-height: 100vh;
}
.card {
  width: 400px;
  position: absolute;
  left: 50%;
  top: 25%;
  transform: translate(-50%, -50%);
}
</style>
